<template>
  <div class="page-container">
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item>maintenance</el-breadcrumb-item>
    </el-breadcrumb> -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">其他功能</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>系统维护公告</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">

        <Create @refresh="refreshList"></Create>
        <el-button
          type="success"
          @click="handleSearch"
          :loading="isLoading"
          icon="el-icon-refresh"
          >刷新</el-button
        >
      </div>

      <user-list @refresh="refreshList" :queryValue="queryValue"></user-list>
    </el-card>
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import Create from "./components/create";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";

export default {
  name: "BlockInfo",
  components: {
    UserList,
    Create,
  },
  data() {
    return {
      seletData: {},
      queryValue: "",
      userStatus: "",
      userType: "",
      mark: "",
      isLoading: false,
      isFinished: "",

  
     
    };
  },
  computed: {
    ...mapState("maintenance", ["queryType", "queryTypeList", "pagination"]),
  },
  methods: {
    ...mapActions("maintenance", ["list", "getGasList"]),
    ...mapActions("transferInner", ["getTransferType"]),
    refreshList(data = {}) {
      this.getGasList({ ...data });
    },
    handleSearch() {
      this.isLoading = true;
      this.getGasList({ ...this.pagination }).then((res) => {
        if (res.code == 0) {
          this.isLoading = false;
        }
      });
    },
  },
  created() {
    // this.getBlockInfoList({
    //   isFinished:'',
    //   disposeStatusInner:'',
    //   ...PAGINATION
    // });
    this.getGasList(this.pagination);
    this.getTransferType();
  },
};
</script>

<style lang="less" scoped>
.page-actions {
  margin-bottom: 10px;
}
</style>
